var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(" 승인 ")]):_c('span',{staticClass:"font-weight-black",class:_vm.request.status},[_vm._v(" "+_vm._s(_vm.code(_vm.request.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }